import loadable from '@loadable/component'

export const ChapterCell = loadable(() => import('./ChapterCell'))
export const TableOfContents = loadable(() => import('./TableOfContents'))
export type { ChapterLinkProps, ChapterCellProps } from './ChapterCell'
export type {
  TableOfContentsItemProps,
  TableOfContentsProps
} from './TableOfContents'
